/* 法人页面交互。
   目前只做一件事：提交瞬间把按钮切成「已提交」并禁用，避免重复提交。

   为什么需要它——Shopify 原生 contact 表单是整页提交，从点击到服务器
   302 回来有 1~3 秒空窗，这段时间按钮仍可点，B 端客户很容易连点两下，
   店主就会收到两封一样的邮件。

   回跳后的「已提交」态由 Liquid 侧根据 contact_posted 参数渲染，
   不在这里处理——那是服务端已知的事实，交给 Liquid 更可靠。 */
(function () {
  'use strict';

  function initForm(root) {
    if (root.dataset.comuB2bReady === 'true') return;
    root.dataset.comuB2bReady = 'true';

    var form = root.querySelector('form');
    var button = root.querySelector('[data-comu-b2b-submit]');
    if (!form || !button) return;

    form.addEventListener('submit', function () {
      // 浏览器原生校验没过时不会走到这里，所以不用自己判 checkValidity
      var sent = button.getAttribute('data-label-sent');
      if (sent) button.textContent = sent;
      button.classList.add('is-submitted');
      // disabled 会让按钮的值不随表单提交——提交按钮本身没有 name，无影响
      button.disabled = true;
    });
  }

  /* 提交成功弹窗。只在提交成功那次由 Liquid 渲染出来，所以这里见到即打开。
     关掉之后把 URL 上的 contact_posted 去掉——否则用户刷新页面弹窗会再来一次。 */
  function initModal(root) {
    var dialog = root.querySelector('[data-comu-b2b-modal]');
    if (!dialog || dialog.dataset.comuB2bModalReady === 'true') return;
    dialog.dataset.comuB2bModalReady = 'true';

    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.has('contact_posted')) {
          url.searchParams.delete('contact_posted');
          window.history.replaceState({}, '', url.toString());
        }
      } catch (e) { /* 老浏览器没有 URL 构造器时不处理，无害 */ }
    }

    Array.prototype.forEach.call(
      dialog.querySelectorAll('[data-comu-b2b-modal-close]'),
      function (btn) { btn.addEventListener('click', close); }
    );
    // 点遮罩关闭：<dialog> 的点击落在 dialog 自身时就是遮罩区
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function boot(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-comu-b2b-form]'),
      initForm
    );
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-comu-b2b-form]'),
      initModal
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // 主题编辑器里切换设置会重载 section，重新绑定
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
